<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs class="page__tabs" hide-slider>
          <v-tab
            :key="i"
            :to="tab.value"
            v-for="(tab, i) in pageParams.tabs"
            :active-class="'white--text financial--background'"
          >
            <span :class="hasLateSlips && tab.icon ? 'enterprise--color' : ''">
              {{ !mobile ? tab.title : tab.titleMobile }}
              <i
                v-if="hasLateSlips && tab.icon"
                :class="`${tab.icon} side-text--icon`"
              />
            </span>
          </v-tab>
        </v-tabs>
        <div class="payment-slip-in-delay__description">{{ description }}</div>
        <div
          v-if="discountCampaignDescription"
          class="payment-slip-in-delay__description"
        >
          {{ discountCampaignDescription }}
        </div>
        <screen-loading v-if="loadingItems"></screen-loading>
        <div v-else-if="error" class="empty-state">
          {{ $t('responses.error') }}
        </div>
        <div v-else>
          <template
            v-if="
              !hasAnticipationSlips &&
              !hasLateError &&
              !hasSolicitationsInProgress
            "
          >
            <empty-state-card :icon="enums.paymentSlipWaitingState.icon">
              <div slot="message">
                Você
                <b>não possui boletos para antecipar.</b>
              </div>
            </empty-state-card>
          </template>
          <template
            v-else-if="
              (debitBlock || hasLateError) && !hasSolicitationsInProgress
            "
          >
            <empty-state-card icon="alert">
              <div slot="message" class="error--color">
                <p class="waiting-state__title">
                  <span>
                    <b>Operação não permitida.</b>
                  </span>
                </p>
                <p class="waiting-state__text">
                  <span>
                    Você possui boleto(s) em atraso, para regularizar o(s)
                    pagamento(s),
                    <router-link
                      class="error--color font-weight-bold"
                      :to="{ name: 'latePaymentSlip' }"
                      tag="a"
                    >
                      <u>clique aqui</u>
                    </router-link>
                  </span>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else>
            <empty-state-card messagePadding="2%" messageClass="xs12 md12 lg12">
              <template slot="message">
                <span class="payment-slip-in-delay__febraban font-weight-bold">
                  {{ latePaymentSlipTooltip }}
                </span>
              </template>
            </empty-state-card>
            <span v-for="(contract, i) in allowedContracts" :key="i">
              <v-card
                v-if="
                  contractsData[contract.id].slips === null ||
                  contractsData[contract.id].slips ||
                  contractsData[contract.id].solicitations
                "
                class="mt-2 mb-2"
              >
                <v-card-title class="pt-headline financial--color">{{
                  getContractTitle(contract)
                }}</v-card-title>
                <screen-loading
                  v-if="contractsData[contract.id].slips === null"
                  margin="20px 25%"
                ></screen-loading>
                <v-card-text v-else>
                  <p
                    v-if="
                      config.texts.lateSlipDetachedContractMessage &&
                      contract.type === enums.contractValues.detached
                    "
                    class="payment-slip-in-delay__description"
                    style="margin: 2px 18px"
                  >
                    {{ config.texts.lateSlipDetachedContractMessage }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      style="color: var(--financial-color); font-weight: bold"
                      :to="{ name: 'ticketForm' }"
                      tag="a"
                    >
                      <u>Abrir nova solicitação</u>
                    </router-link>
                  </p>

                  <empty-state-card
                    v-if="
                      !inDelaySolicitationAllowed &&
                      contractsData[contract.id].currSolicitationStep ===
                        SOLICITATIONS_PAGE_STEPS.INITIAL
                    "
                    icon="alert"
                  >
                    <div slot="message" class="error--color">
                      <p class="waiting-state__title">
                        <span>
                          <b>Operação não permitida.</b>
                        </span>
                      </p>

                      <p class="waiting-state__text">
                        <span
                          >Em caso de dúvidas, favor entrar em contato com a
                          Central de Relacionamento.</span
                        >
                      </p>

                      <p class="waiting-state__text">
                        <router-link
                          v-if="ticketCrmEnabled"
                          class="error--color font-weight-bold"
                          :to="{ name: 'ticketForm' }"
                          tag="a"
                        >
                          <u>Abrir nova solicitação</u>
                        </router-link>
                      </p>
                    </div>
                  </empty-state-card>
                  <div v-else class="table-stepper-container">
                    <template
                      v-if="
                        (!contractsData[contract.id].solicitations ||
                          contractsData[contract.id].solicitations.length ==
                            0) &&
                        (!contractsData[contract.id].slips ||
                          contractsData[contract.id].slips.length == 0)
                      "
                    >
                      <empty-state-card
                        :icon="enums.paymentSlipWaitingState.icon"
                      >
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>{{ pageParams.emptyState.anticipation }}</b>
                            </span>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                    <table-stepper-legacy
                      v-else-if="!contractsData[contract.id].systemDischarge"
                      v-model="contractsData[contract.id].currSolicitationStep"
                      v-bind="enums.paymentSlipRequestSteps"
                      :no-data-text="pageParams.emptyState.anticipation"
                      :items="
                        contractsData[contract.id].solicitations &&
                        contractsData[contract.id].solicitations.length > 0
                          ? contractsData[contract.id].solicitations
                          : contractsData[contract.id].slips || []
                      "
                      :loading="loadingApp"
                      :headers="
                        contractsData[contract.id].currSolicitationStep ===
                        SOLICITATIONS_PAGE_STEPS.INITIAL
                          ? firstStepHeaders
                          : headers
                      "
                      :mobileHeaders="
                        contractsData[contract.id].currSolicitationStep ===
                        SOLICITATIONS_PAGE_STEPS.INITIAL
                          ? firstStepMobileHeaders
                          : mobileHeaders
                      "
                      @updateSelected="
                        (v) => {
                          contractsData[contract.id].selected = v;
                        }
                      "
                      buttonClass="white--text financial--background"
                      totalKey="paidValue"
                      totalLabel="Total"
                      sort-icon="bexsicon-down"
                      itemKey="id"
                      :buttonText="enums.paymentSlipRequestButtonText"
                      @buttonClicked="solicitateSlip(contract.id)"
                      :buttonLoading="loadingSolicitation"
                      :activeClass="`
                      financial--background
                      financial--border-color
                      all--white`"
                      ignorePrevious
                      :footerEmptyCols="footerEmptyCols"
                    >
                      <template slot="firstStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td
                          v-if="discountCampaign.hasDiscountCampaign"
                          class="text-xs-center bold--text"
                        >
                          {{ formatMoney(props.item.discount) }}
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.updatedValueEndMonth) }}
                        </td>
                        <td @click.stop class="text-xs-center mw-12">
                          <text-field
                            class="input-slim"
                            ref="paidValue"
                            v-model.lazy="props.item.paidValue"
                            v-money="money"
                            required
                            :rules="
                              validateValue(
                                props.item.discountedValue,
                                props.item.paidValue
                              )
                            "
                          ></text-field>
                        </td>
                        <td
                          v-if="!mobile"
                          @click.stop
                          class="text-xs-center"
                        ></td>
                      </template>
                      <template slot="secondStepTableItems">
                        <empty-state-card
                          :icon="enums.paymentSlipWaitingState.icon"
                        >
                          <div slot="message">
                            <p
                              :class="`waiting-state__title ${
                                contractsData[contract.id].error
                                  ? 'error--text'
                                  : ''
                              }`"
                            >
                              {{
                                $t(
                                  enums[
                                    contractsData[contract.id].error
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].title
                                )
                              }}
                            </p>
                            <p class="waiting-state__text">
                              {{
                                $t(
                                  enums[
                                    contractsData[contract.id].error
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].firstLine,
                                  { slipTimeoutHours }
                                )
                              }}
                              <router-link
                                v-if="
                                  ticketCrmEnabled &&
                                  contractsData[contract.id].error
                                "
                                :to="{ name: 'ticketForm' }"
                                tag="a"
                              >
                                <u>{{ enums.paymentSlipError.link }}</u>
                              </router-link>
                            </p>
                          </div>
                        </empty-state-card>
                      </template>
                      <template slot="thirdStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td
                          v-if="discountCampaign.hasDiscountCampaign"
                          class="text-xs-center bold--text"
                        >
                          -
                        </td>
                        <td
                          v-if="discountCampaign.hasDiscountCampaign"
                          class="text-xs-center bold--text"
                        >
                          -
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.paymentTotal) }}
                        </td>
                        <td class="text-xs-center">
                          <PaymentButton
                            :item="props.item"
                            :email="email"
                            :cellphone="cellphone"
                            :buttonClass="'financial--background table-btn'"
                            @openSlip="paySlip(props.item)"
                            :sendByEmail="sendSlipByEmailAnticipation"
                            :sendBySms="sendSlipBySmsAnticipation"
                          >
                            <template v-slot:tooltip>
                              <v-tooltip
                                z-index="99"
                                top
                                color="grey lighten-3"
                                max-width="300"
                              >
                                <span class="tooltip__text no-print">{{
                                  latePaymentSlipTooltip
                                }}</span>
                                <span slot="activator">
                                  <i
                                    class="bexsicon-info tooltip__icon indelay-slips-tooltip"
                                  />
                                </span>
                              </v-tooltip>
                            </template>
                          </PaymentButton>
                        </td>
                        <td
                          v-if="!discountCampaign.hasDiscountCampaign"
                          class="text-xs-center bold--text"
                        ></td>
                      </template>
                    </table-stepper-legacy>
                    <template v-else>
                      <empty-state-card icon="alert">
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>
                                Estamos aguardando o pagamento do boleto gerado
                                {{
                                  contractsData[contract.id].solicitations
                                    ? ' com vencimento no dia ' +
                                      formatDate(
                                        contractsData[contract.id].solicitations
                                          .expirationDate
                                      )
                                    : ''
                                }}.
                              </b>
                            </span>
                          </p>
                          <p class="waiting-state__text">
                            <span>{{ waitingText }}</span>
                          </p>
                          <p class="waiting-state__text">
                            <router-link
                              v-if="ticketCrmEnabled"
                              class="financial--color font-weight-bold"
                              :to="{ name: 'ticketForm' }"
                              tag="a"
                            >
                              <u>Abrir nova solicitação</u>
                            </router-link>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </span>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import moment from 'moment-timezone';
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TableStepperLegacy from '@/components/financial/TableStepperLegacy';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import PaymentButton from '@/components/financial/PaymentButton';
import anticipationPaymentSlipMixin from '@/mixins/modules/anticipationPaymentSlip';
import notificationTypes from '@/utils/notificationTypes';
import getSlipUrl from '@/services/getSlipUrl';
import TextField from '@/components/fields/TextField';
import { VMoney } from 'v-money';
import {
  APP,
  CONFIG,
  NOTIFICATIONS,
  ROLES,
  SOLICITATE_TYPE,
  USER,
  TICKET_CRM,
  SOLICITATIONS_PAGE_STEPS,
} from '../../utils/constants';

export default {
  name: 'anticipationPaymentSlip',
  components: {
    ModulePage,
    ScreenLoading,
    TableStepperLegacy,
    EmptyStateCard,
    TextField,
    PaymentButton,
  },
  mixins: [anticipationPaymentSlipMixin],
  computed: {
    imobmeUser() {
      return this.$store.getters[USER.GET_IMOBME_DATA];
    },
    unitContracts() {
      return this.selectedUnit.contracts;
    },
    hasSolicitationsInProgress() {
      return this.unitContracts.some(
        (contract) =>
          (this.contractsData[contract.id].solicitations || []).length
      );
    },
    allSolicitations() {
      return this.unitContracts.reduce(
        (contractsSolicitations, contract) =>
          contractsSolicitations.push(
            ...this.contractsData[contract.id].solicitations
          ),
        []
      );
    },
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    financialRule() {
      return this.$store.getters[CONFIG.GET_FINANCIAL_RULE];
    },
    debitBlock() {
      return (
        this.unitContracts.some((contract) => contract.debitBlock) || false
      );
    },
    latePaymentSlipTooltip() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .latePaymentSlipTooltip;
    },
    allowedContracts() {
      const { LATE_SLIPS } = enums.financialModules;
      return this.getAllowedContracts(LATE_SLIPS, this.unitContracts);
    },
    slipTimeoutHours() {
      return this.$store.getters[CONFIG.GET_SLIP_TIMEOUT_HOURS];
    },
    headers() {
      return [
        {
          text: 'Vencimento',
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor',
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          visible: true,
        },
        {
          text: '',
          value: '',
          align: 'center',
          sortable: false,
          visible: true,
        },
      ].filter((x) => x.visible !== false);
    },
    firstStepHeaders() {
      return [
        {
          text: 'Vencimento',
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha**',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor Atualizado',
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar*',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          visible: true,
        },
        {
          text: '',
          value: '',
          align: 'center',
          sortable: false,
          visible: true,
        },
      ].filter((x) => x.visible !== false);
    },
    mobileHeaders() {
      return [
        {
          text: 'Vencimento',
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor Atualizado',
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          visible: true,
        },
      ].filter((x) => x.visible !== false);
    },
    firstStepMobileHeaders() {
      return [
        {
          text: 'Vencimento',
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha**',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Valor Atualizado',
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar*',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          visible: true,
        },
      ].filter((x) => x.visible !== false);
    },
  },
  data() {
    return {
      SOLICITATIONS_PAGE_STEPS,
      slips: {},
      pageParams: this.$store.getters[APP.PAGES].paymentSlip,
      loadingSolicitation: false,
      description: '',
      discountCampaignDescription: '',
      currSolicitationStep: {},
      solicitations: {},
      selected: {},
      solicitationErrors: {},
      hasLateError: false,
      hasAnticipationSlips: false,
      waitingText:
        'Aguarde 4 dias após o vencimento para gerar novos boletos. Em caso de dúvida, entre em contato com a Central de Relacionamento.',
      error: false,
      loadingItems: false,
      // systemDischarge: {},
      contractsData: {},
      discountCampaign: {
        hasDiscountCampaign: false,
        allowedParcelTypes: [],
        allowedFrequencyTypes: [],
        releaseProRata: false,
      },
      hasLateSlips: false,
      footerEmptyCols: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      email: '',
      cellphone: {
        countryCode: '+55',
        areaCode: '',
        number: '',
      },
    };
  },

  directives: { money: VMoney },

  created() {
    bus.$on('unit:change', this.setItems);
    bus.$on('unit:update', this.setItems);

    for (const { id } of this.unitContracts) {
      this.contractsData[id] = {
        selected: [],
        slips: [],
        solicitations: [],
        error: false,
        currSolicitationStep: SOLICITATIONS_PAGE_STEPS.INITIAL,
        systemDischarge: false,
      };
    }

    this.email = this.user.email;
    if (this.imobmeUser && this.imobmeUser.cellphone) {
      const { number, areaCode, countryCode } = this.imobmeUser.cellphone;
      this.cellphone = { number, areaCode, countryCode: countryCode || '+55' };
    }

    this.description = this.pageParams.texts.inDelayDescription;

    this.setItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.setItems);
    bus.$off('unit:update', this.setItems);
  },
  methods: {
    setItems(unitObj = null) {
      this.formatSelecteds();
      this.getItems();
    },

    formatSelecteds() {
      for (const { id } of this.unitContracts) {
        this.contractsData[id].currSolicitationStep =
          SOLICITATIONS_PAGE_STEPS.INITIAL;
      }
    },

    validateValue(currentValue, newValue) {
      let message = [];
      const value =
        typeof newValue === 'string'
          ? this.parseMoneyComma(newValue)
          : newValue;

      const balance = currentValue - value;

      if (value !== currentValue) {
        if (value <= 0) {
          message.push(`O valor digitado não pode ser menor ou igual a zero!`);
        }
        if (value > currentValue) {
          message.push(
            `O valor digitado não pode ser maior do que ${this.formatMoney(
              currentValue
            )}!`
          );
        }
        if (value < this.financialRule.minAmortization) {
          message.push(
            `O valor mínimo para antecipação é de ${this.formatMoney(
              this.financialRule.minAmortization
            )}!`
          );
        }
        if (balance < this.financialRule.minBalance) {
          message.push(
            `O valor restante não pode ser menor do que ${this.formatMoney(
              this.financialRule.minBalance
            )}!`
          );
        }
      }

      return message;
    },

    paySlip(slip) {
      if (slip.slipUrl.hash) {
        window.open(getSlipUrl(slip.slipUrl.hash));
      } else {
        window.open(slip.slipUrl);
      }

      const notification = {
        id: slip._id,
        type: notificationTypes.LATE_SLIPS,
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
        ctx: this,
        notification,
      });
      const contract = this.unitContracts.find(
        ({ id }) => id === slip.contractId
      );
      const traceInfo = {
        contractId: slip.contractId,
        contractType: contract.type,
        detachedType: this.getContractTitle(contract),
        paymentTotal: slip.paymentTotal,
        solicitationCode: slip.solicitationCode,
        expirationDate: slip.expirationDate,
        parcels: slip.parcels,
        url: slip.slipUrl,
      };
      const traceAction = enums.logTraceActions.anticipationPaymentSlipDownload;
      this.createTrace(traceAction, traceInfo);
    },

    async solicitateSlip(contractId) {
      if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
      if (this.loadingSolicitation) return;
      try {
        this.loadingSolicitation = true;

        const parcels = this.contractsData[contractId].selected;

        let paidFields = this.$refs['paidValue'];
        for (const field of paidFields) {
          if (!field.validate()) {
            return;
          }
        }

        if (!parcels || parcels.length === 0) return;

        const contract = this.unitContracts.find(({ id }) => id === contractId);

        const body = {
          contractId,
          contractType: contract.type,
          productSku: this.selectedUnit.sku,
          parcels: parcels.map(
            ({
              noChargeValue,
              paidValue,
              parcelCode,
              serieId,
              serieCode,
              id,
              expirationDate,
              discountedValue,
              discount,
              proRata,
              spe,
            }) => {
              let proRataValue = this.discountCampaign.releaseProRata
                ? proRata || 0.0
                : 0.0;
              let paidValueUnformated = this.parseMoneyComma(paidValue);
              let discountUnformated = parseFloat(discount);
              let integralValue = parseFloat(
                (paidValueUnformated + discountUnformated).toFixed(2)
              );

              if (integralValue !== discountedValue && discountUnformated > 0) {
                discountUnformated = 0;
                integralValue = paidValueUnformated;
                proRataValue = 0;
              }

              return {
                noChargeValue,
                discountedValue: integralValue,
                parcelCode,
                serieId,
                serieCode,
                id,
                expirationDate,
                discount: -(discountUnformated - proRataValue),
                proRata,
                spe,
              };
            }
          ),
          solicitationType: SOLICITATE_TYPE.ANTICIPATION,
          totalDiscount: 0.0,
          releaseProRata: this.discountCampaign.releaseProRata,
        };

        body.totalDiscount = body.parcels.reduce(
          (total, parcel) => total + parcel.discount,
          0
        );

        const result = await this.requestService(
          `${process.env.FINANCIAL_API_URL}/solicitation/save`,
          'POST',
          {
            data: body,
          }
        );

        if (result) {
          this.contractsData[contractId].currSolicitationStep =
            SOLICITATIONS_PAGE_STEPS.WAITING;

          this.$forceUpdate();

          const traceAction =
            enums.logTraceActions.anticipationPaymentSlipSolicitation;
          const traceInfo = {
            contractId: result.contractId,
            contractType: contract.type,
            detachedType: this.getContractTitle(contract),
            paymentTotal: result.paymentTotal,
            solicitationCode: result.solicitationCode,
            expirationDate: result.expirationDate,
            parcels,
          };
          this.createTrace(traceAction, traceInfo);
        }
      } catch (e) {
        console.error({ ...e });

        if (e.status === 500) {
          this.error = true;
        }
      } finally {
        this.loadingSolicitation = false;
      }
    },

    async getItems() {
      try {
        this.error = false;
        this.loadingItems = true;

        const contractsToGetSlips = [...this.allowedContracts];
        let solicitationsByContract = [];

        if (contractsToGetSlips.length > 0) {
          let promises = [
            this.getAnticipationSolicitations(contractsToGetSlips),
            this.getDiscountCampaign(),
            this.getAnticipationPaymentSlips(contractsToGetSlips),
          ];
          let [solicitationsByContractList] = await Promise.all(promises);
          solicitationsByContract = solicitationsByContractList;
        }

        //? interface ContractSolicitation {
        //?   contractId: number;
        //?   inProgress: boolean;
        //?   error: boolean;
        //?   ready: boolean;
        //?   systemDischarge: boolean;
        //?   items: SolicitationResultType[];
        //?   logGenerated: boolean;
        //?   logError: boolean;
        //?   logExpired: boolean;
        //? }
        for (const contractSolicitation of solicitationsByContract) {
          let hasSomethingToShow = false;
          const contractId = contractSolicitation.contractId;

          if (contractSolicitation.systemDischarge) {
            this.contractsData[contractId].solicitations =
              contractSolicitation.items[0] || null;
            this.contractsData[contractId].systemDischarge = true;

            hasSomethingToShow = true;
          } else if (
            contractSolicitation.inProgress ||
            contractSolicitation.error
          ) {
            this.contractsData[contractId].currSolicitationStep =
              SOLICITATIONS_PAGE_STEPS.WAITING;
            this.contractsData[contractId].solicitations =
              contractSolicitation.items[0] || null;
            this.contractsData[contractId].error = contractSolicitation.error;

            hasSomethingToShow = true;
          } else if (contractSolicitation.ready) {
            // Add barcode into parcel
            for (const solicitation of contractSolicitation.items) {
              // solicitation.ready = true;
              if (!solicitation.barcode) {
                for (const parcel of solicitation.parcels) {
                  const { barcode } =
                    this.contractsData[solicitation.contractId].slips.find(
                      (s) =>
                        s.serieId === parcel.serieId &&
                        s.parcelCode === parcel.parcelCode
                    ) || {};
                  if (!solicitation.barcode && barcode) {
                    solicitation.barcode = barcode;
                  }
                }
              }
            }

            this.contractsData[contractId].solicitations =
              contractSolicitation.items;
            this.contractsData[contractId].currSolicitationStep =
              SOLICITATIONS_PAGE_STEPS.READY;

            hasSomethingToShow = true;
          }

          if (
            hasSomethingToShow &&
            this.contractsData[contractId].solicitations
          ) {
            const contractIndex = contractsToGetSlips.findIndex(
              (o) => o.id === contractId
            );
            if (contractIndex !== -1)
              contractsToGetSlips.splice(contractIndex, 1);
          }
        }

        this.$forceUpdate();
      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        this.loadingItems = false;
      }
    },

    async getDiscountCampaign() {
      let hasCampaign = false;
      const today = moment().startOf('day').format('YYYY-MM-DD');
      const query = {
        active: true,
        productsById: {
          $in: [this.selectedUnit.product.id, '*'],
        },
        $nor: [
          {
            validTo: {
              $lt: today,
            },
          },
          {
            validFrom: {
              $gt: today,
            },
          },
        ],
      };

      const resultDiscountCampaign = await this.requestService(
        `${process.env.CRUD_API_GET}/discountCampaign`,
        'GET',
        {
          params: { filter: { query } },
          localErrorHandling: true,
        }
      );

      if (resultDiscountCampaign.items.length) {
        const campaign = resultDiscountCampaign.items[0];

        hasCampaign = true;

        if (campaign.productsById.indexOf('*') === -1) {
          if (campaign.groups.length) {
            const resultGroup = await this.requestService(
              `${process.env.CRUD_API_GET}/group`,
              'GET',
              {
                localErrorHandling: true,
              }
            );

            if (resultGroup.items.length) {
              resultGroup.items.forEach((g) => {
                campaign.products.push(...g.products);
              });
            }
          }

          if (!campaign.products.some((p) => p.id === '*')) {
            const productsCampaign = campaign.products.filter(
              (p) => parseInt(p.id) === this.selectedUnit.product.id
            );
            const blocksCampaign = productsCampaign.map((p) => p.blocks);
            const blockIds = [];

            blocksCampaign.forEach((b) => {
              if (b.length) {
                b.forEach((i) => {
                  blockIds.push(parseInt(i.id));
                });
              }
            });

            if (blockIds.length) {
              hasCampaign = blockIds.some(
                (id) => id === this.selectedUnit.block.id
              );
            }
          }
        }

        if (hasCampaign) {
          this.discountCampaign.hasDiscountCampaign = hasCampaign;
          this.discountCampaign.allowedParcelTypes = campaign.parcelTypes;
          this.discountCampaign.allowedFrequencyTypes = campaign.frequencyTypes;
          this.discountCampaign.discountPercent = campaign.discount;
          this.discountCampaign.releaseProRata = campaign.releaseProRata;
          this.footerEmptyCols = this.footerEmptyCols + 1;
          this.discountCampaignDescription =
            this.pageParams.texts.discountCampaignDescription;
        }
      }
    },

    async getAnticipationPaymentSlips(contractsToRequest) {
      try {
        const url = process.env.ANTICIPATION_PAYMENT_SLIPS_API_URL;

        this.hasAnticipationSlips = false;

        const params = {
          contractIds: contractsToRequest.map((contract) => contract.id),
          contractTypes: contractsToRequest.map((contract) => contract.type),
        };

        const res = await this.requestService(url, 'GET', {
          params,
          localErrorHandling: true,
        });

        if (res.hasLate) {
          this.hasLateSlips = true;
          this.hasLateError = true;
        } else {
          for (const contract of res.items) {
            const contractId = contract.contractId;
            this.contractsData[contractId].slips = [];

            const parcels = contract.parcels.map((o) => {
              const discountObtained = this.calculateDiscountCampaign(o);
              const paidValueCalculated = o.discountedValue - discountObtained;
              return {
                contractId,
                paidValue: this.formatMoney(paidValueCalculated),
                discount: discountObtained,
                ...o,
              };
            });

            this.contractsData[contractId].slips.push(...parcels);
            // this.slips = { ...this.slips };
            if (!this.hasAnticipationSlips) this.hasAnticipationSlips = true;
            this.loadingItems = false;
          }
        }
      } catch (err) {
        throw err;
      }
    },

    calculateDiscountCampaign(parcel) {
      let result = 0.0;
      const isTypeValid = this.discountCampaign.allowedParcelTypes.some(
        (p) => p === parcel.type
      );
      const isFrequencyValid = this.discountCampaign.allowedFrequencyTypes.some(
        (p) => p === parcel.frequency
      );
      const proRataValue =
        this.discountCampaign.releaseProRata && parcel.proRata
          ? parcel.proRata
          : 0.0;

      if (isTypeValid && isFrequencyValid) {
        const additionalDiscount = parseFloat(
          (
            (parcel.discountedValue - proRataValue) *
            (this.discountCampaign.discountPercent / 100)
          ).toFixed(2)
        );
        result = additionalDiscount + proRataValue;
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.input-slim {
  font-size: inherit;
}

.waiting-state {
  &__title {
    margin: 0;
    font-weight: var(--font-weight);
  }
  &__text {
    margin: 0;
    font-size: 11px;
  }
}

.indelay-slips-tooltip {
  padding: 12px 0;
}

.table-stepper-container {
  padding: 16px;

  @include breakpoint(mobile) {
    padding: 0px;
  }
}

.payment-slip-in-delay {
  &__description {
    font-size: 12px;
    padding-bottom: 10px;
    color: var(--label-color);
  }
  &__febraban {
    font-size: var(--payment-slip-in-size);
    padding-bottom: 10px;
    color: var(--payment-slip-in-color);
  }
}

>>> .v-table__overflow {
  @include breakpoint(mobile) {
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/financial/AnticipationPaymentSlip.vue